/**
 * Sistema de Precificação MotoVeloz
 * 
 * Preço cadastrado = preço do cartão (cheio)
 * Preço PIX = preço cadastrado - 10%
 * Parcelamento calculado sobre o preço cadastrado (cheio)
 */

export function getPixPrice(precoCadastrado) {
  return Math.round((precoCadastrado / 1.1) * 100) / 100;
}

export function getInstallments(precoCadastrado) {
  if (precoCadastrado < 100) return null;
  let parcelas;
  if (precoCadastrado < 180) parcelas = 2;
  else if (precoCadastrado < 250) parcelas = 3;
  else if (precoCadastrado < 350) parcelas = 4;
  else if (precoCadastrado < 500) parcelas = 5;
  else parcelas = 6;
  const valor = Math.round((precoCadastrado / parcelas) * 100) / 100;
  return { parcelas, valor };
}

export function formatPrice(value) {
  return value.toFixed(2).replace('.', ',');
}
